export default __webpack_public_path__ + "static/media/reward.29298168.png";